/**
 * Edits a wait card on the campaign that is open, or on the server
 * when the reminder is answered from the bell and that campaign is closed.
 */

import { SprintAPI } from './api/sprintApi';

let applyPatch = null;

export function bindWaitCardEditor(apply) {
  applyPatch = apply;
  return () => {
    if (applyPatch === apply) applyPatch = null;
  };
}

export function patchWaitCard(taskId, patch, campaignId) {
  if (!applyPatch || !taskId || !patch) return false;
  return applyPatch(taskId, patch, campaignId) === true;
}

export async function fulfillWaitFromInbox({ campaignId, taskId, workspaceId }) {
  const fulfilledAt = new Date().toISOString();
  const patch = { fulfilledAt };
  if (patchWaitCard(taskId, patch, campaignId)) return { ok: true };
  if (!campaignId || !taskId) return { ok: false };
  const sprint = await SprintAPI.get(campaignId, { workspaceId });
  if (!sprint || !Array.isArray(sprint.tasks)) return { ok: false };
  const tasks = sprint.tasks.map((task) => (
    task.id === taskId ? { ...task, fulfilledAt, updatedAt: fulfilledAt } : task
  ));
  await SprintAPI.update(campaignId, { ...sprint, tasks }, { workspaceId });
  return { ok: true };
}
